import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { JoyrideModule } from 'ngx-joyride';
import { Angulartics2Module } from 'angulartics2';

import {
  ChatCounterModule,
  CommonRadioGroupModule,
  CommonUiModule,
  FormValidationModule,
  UtilsModule,
  SortableColumnModule,
} from '@tablesready/common-ui';
import { BadgeModule } from '@tablesready/frontend-badge';
import { WhatsappToggleModule } from '@tablesready/frontend-whatsapp-toggle';
import { FrontendCountdownTimerModule } from '@tablesready/frontend-countdown-timer';
import { WaitlistComponent } from './waitlist.component';
import { WaitlistRoutingModule } from './waitlist.routing.module';
import {
  CustomMaxDirective,
  CustomMinDirective,
  TelephonePipe,
} from './pipes';
import { EditResourcesComponent } from './components';
import {
  ChatPartyModule,
  WaitlistAddEditPartyModule,
  WaitlistQuotedTimeModule,
} from '../components';
import { WaitlistActionsModule } from '../components/waitlist-actions';
import { WaitlistNotifyModule } from '../components/waitlist-notify/waitlist-notify.module';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { LocationSwitcherModule } from '@tablesready/frontend-location-switcher';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule, ClockModule } from '@tablesready/frontend-alerts-bar';
import { AppVariablesModule } from '@tablesready/frontend-variables';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    WaitlistComponent,
    TelephonePipe,
    CustomMaxDirective,
    CustomMinDirective,
    EditResourcesComponent,
  ],
  imports: [
    WaitlistAddEditPartyModule,
    CommonRadioGroupModule,
    CommonModule,
    FormsModule,
    CommonUiModule,
    ReactiveFormsModule,
    AlertsModule,
    ClockModule,
    AppVariablesModule,
    StatusModule,
    UtilsModule,
    FormValidationModule,
    NgbModule,
    InfiniteScrollModule,
    NgSelectModule,
    WaitlistRoutingModule,
    ChatCounterModule,
    JoyrideModule.forChild(),
    Angulartics2Module,
    BadgeModule,
    LocationSwitcherModule,
    SortableColumnModule,
    ChatPartyModule,
    WaitlistActionsModule,
    WaitlistNotifyModule,
    WaitlistQuotedTimeModule,
    WhatsappToggleModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
    FrontendCountdownTimerModule,
  ],
})
export class WaitlistModule { }
